<template>
    <b-card class="contenedor">

        <div slot="header" class="font-weight-bold">
            Inventario - Reporte <span v-if="usuarioEmpresaContratista">contratistas</span>
        </div>

        <b-row class="d-flex">
            <b-col sm="6" v-if="!usuarioEmpresaContratista">
                <b-form-group label="Empresa" horizontal="">
                    <el-select v-model="companySelected.id"
                        @change="onCompanyChange"
                        filterable remote clearable no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" :remote-method="buscarEmpresa">
                        <el-option v-for="item in listaEmpresas" :key="item.id" :label="item.nombre" :value="item.id">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col sm="6" v-if="companySelected.id && allCountries.length >= 1">
                <b-form-group label="País" horizontal="">
                    <el-select v-model="country_id" filterable clearable no-data-text="No hay datos que coincidan"
                        :disabled="!companySelected.id" no-match-text="No hay datos que coincidan">
                        <el-option v-for="item in allCountries" :key="item.country.id" :label="item.country.name"
                            :value="item.country.id">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col sm="6" v-if="companySelected.id">
                <b-form-group>
                    <label for="bases">Ubicaciones</label>
                    <treeselect v-model="val" :multiple="true" :options="treeWithChildrens" :defaultExpandLevel="Infinity"
                        :normalizer="normalizer" :show-count="true" value-consists-of="ALL_WITH_INDETERMINATE"
                        @input="setFiltroUbicacion" />
                </b-form-group>
            </b-col>
            <b-col sm="6" v-if="!usuarioEmpresaContratista">
                <b-form-group>
                    <label for="">Tipos de reporte</label>
                    <el-select v-model="inventoryTypeId" filterable clearable
                        placeholder="Selecciona el tipo de reporte" :disabled="usuarioEmpresaContratista">
                        <el-option v-for="item in inventoryTypes" :key="item.id" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col sm="3" v-if="inventoryTypeId === 'ACT_INVENT'">
                <b-form-group label="Incluir datos de productos">
                    <el-select v-model="report_with_data" placeholder="Incluir datos de productos">
                        <el-option label="SI" value="1"></el-option>
                        <el-option label="NO" value="0"></el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col sm="3">
                <b-form-group>
                    <label for="">Disponible en el inventario</label>
                    <el-select v-model="in_use" clearable placeholder="Usabilidad">
                        <el-option v-for="item in [{ id: 1, name: 'SI' }, { id: 0, name: 'NO' }]" :key="item.id"
                            :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col sm="3">
                <b-form-group>
                    <label for="">Campos personalizados</label>
                    <el-select v-model="use_custom_fields" placeholder="Campos personalizados">
                        <el-option v-for="item in [{ id: 1, name: 'Si' }, { id: 0, name: 'No' }]" :key="item.id"
                            :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col>

            <!-- <b-col sm="3" v-if="validarPermisoComponente('ver-filtro-idioma-inventario')">
                <b-form-group>
                    <label for="language">Idioma</label>
                    <el-select v-model="languageCode" filterable clearable no-data-text="No hay datos que coincidan"
                        no-match-text="No hay datos que coincidan" @change="getAllLanguages">
                        <el-option v-for="item in languages" :key="item.id" :label="item.name" :value="item.code">
                        </el-option>
                    </el-select>
                </b-form-group>
            </b-col> -->

            <b-col sm="3">
                <b-form-group>
                    <label for="">Tipos de productos a descargar</label>
                    <el-select v-model="type_products" placeholder="Tipos de productos a descargar">
                        <el-option label="Verificados" value="VERIFIED"></el-option>
                        <el-option label="Asignados RPQ" value="ASSIGNED_RPQ"></el-option>
                        <el-option label="Caracterizados" value="CHARACTERIZED" selected></el-option>
                    </el-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="d-flex mt-2">
            <b-col sm="6" md="auto" class="d-flex">
                <button size="sm" @click="generateScheduleInventoryReport()" class="btn btn-primary"
                    :disabled="!companySelected || !inventoryTypeId">
                    <i class="fa fa-check" /> Generar
                </button>
                <b-button size="sm" :disabled="!companySelected.id" variant="info" @click="showProccessBackground()"
                    class="ml-2">
                    Consultar reportes agendados
                </b-button>
                <button size="sm" @click="generateScheduleGlobalInventoryReport()" class="btn btn-primary ml-2"
                    v-if="validarPermisoComponente('descargar-inventario-global')">
                    <i class="fa fa-check" /> Reporte global
                </button>
                <b-button v-if="validarPermisoComponente('descargar-inventario-global')" size="sm" variant="info"
                    @click="showProccessBackground('SI')" class="ml-2">
                    Consultar reportes globales
                </b-button>
            </b-col>
        </b-row>
        <hr />
        <ModalProcessBackground :inventoryTypes="inventoryTypes" :company_id="companySelected.id" />
    </b-card>
</template>
<script>

// Importaciones generales
import { mapState, mapMutations, mapActions } from "vuex";
import useCompanyCountries from '../../../composables/country/useCompanyCountries'
import useCompanyLocationsTree from '../../../composables/location/useCompanyLocationsTree'

// Componentes
import Swal from 'sweetalert2'
import Treeselect from "@riophae/vue-treeselect";

import { getAcls } from "@/plugins/acl";
import ModalProcessBackground from './../Modals/ModalProcessBackground'
import { validarPermisoComponente } from '../../../plugins/acl';
export default {
    components: {
        Treeselect,
        ModalProcessBackground
    },
    mixins: [useCompanyCountries, useCompanyLocationsTree],
    async mounted() {

        // Contratistas
        if (this.usuarioEmpresaContratista) {

            try {

                const dataBase64User = localStorage.getItem('acl');
                let companyData = dataBase64User.replaceAll('"', '');
                companyData = JSON.parse(window.atob(companyData))

                if (typeof companyData === 'object' && 'info_empresa' in companyData) {

                    this.companySelected.id = companyData.info_empresa.id;
                    this.companySelected.nombre = companyData.info_empresa.nombre;

                    await this.listarUbicacionesEmpresa(companyData.empresa);
                    await this.getEmpresa(companyData.empresa);

                    // Aplicar selección automática después de cargar el árbol
                    if (this.locations_user && this.locations_user.length > 0) {
                        const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(companyData.info_empresa.id, this.locations_user, null, this.my_company);
                        if (selectedLocationIds && selectedLocationIds.length > 0) {
                            this.val = selectedLocationIds;
                            this.setFiltroUbicacion(selectedLocationIds);
                        }
                    }

                    this.load(true);

                } else {
                    Swal.fire({
                        position: 'center',
                        icon: 'info',
                        title: 'Reporte inventario contratistas',
                        text: 'Ups, la empresa activa esta presentando problemas, por favor e intentalo de nuevo.',
                        showConfirmButton: true
                    });
                }

            } catch (e) {
                Swal.fire({
                    position: 'center',
                    icon: 'error',
                    title: 'Reporte inventario contratistas',
                    text: 'Ups, la empresa activa esta presentando problemas, por favor e intentalo de nuevo.',
                    showConfirmButton: true
                });
            }

        }

        await this.getInventoryTypes();
        await this.getAllLanguages();
    },
    data() {
        return {
            inventoryTypes: [],
            inventoryTypeId: null,
            in_use: 1,
            companySelected: {
                id: null,
                nombre: null,
            },
            val: null,
            isMyS: false,
            use_custom_fields: 0,
            type_products: 'CHARACTERIZED',
            report_with_data: "1",
            validarPermisoComponente: validarPermisoComponente,
            languageCode: 'ES',
            country_id: null,
        };
    },
    methods: {
        normalizer(node) {
            return {
                id: node.id,
                label: node.label,
                children: Array.isArray(node.children) && node.children.length ? node.children : undefined,
                raw: node,
            };
        },
        async getInventoryTypes() {
            const res = await this.listInventoryType(this.country_id);

            // Controlar acciones para tipos de usuarios
            if (typeof res === 'object' && this.usuarioEmpresaContratista) {

                // Solo se permiten los tipos de reporte ("Contratista")
                this.inventoryTypes = res.filter(x => x.code == "CONT");

                // Setear el tipo de inventario
                this.inventoryTypeId = (this.inventoryTypes.length > 0) ? this.inventoryTypes[0].code : null
                this.inventoryTypeIdTemporary = (this.inventoryTypes.length > 0) ? this.inventoryTypes[0].id : null

            }
            else this.inventoryTypes = res
        },
        async buscarEmpresa(nombre) {
            if (nombre.length >= 3) {
                let data = { nombre: nombre };
                this.load(true);
                await this.getEmpresas(data);
                this.load(false);
            }
        },
        async onCompanyChange() {
            this.limpiaEmpresa();
            if (this.companySelected.id) {
                this.country_id = null;
                this.val = null;
                await this.getAllCountriesByCompany(this.companySelected.id);

                // Aplicar selección automática después de cargar el árbol
                if (this.locations_user && this.locations_user.length > 0) {
                    const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(this.companySelected.id, this.locations_user, null, this.my_company);
                    if (selectedLocationIds && selectedLocationIds.length > 0) {
                        this.val = selectedLocationIds;
                        this.setFiltroUbicacion(selectedLocationIds);
                    }
                } else {
                    await this.loadLocationsTree(this.companySelected.id, null);
                }
            } else {
                this.country_id = null;
                this.val = null;
            }
        },
        async generateScheduleInventoryReport() {
            const acls = getAcls();
            let dataRepor = {
                company_id: this.companySelected.id,
                company_name: this.empresa.nombre,
                locations: this.selectedInventario.ubicaciones,
                report_type: this.inventoryTypeId,
                is_mys: this.isMyS === true ? 1 : 0,
                uuid: acls.uuid,
                empresa: this.companySelected.id,
                in_use: this.in_use,
                use_custom_fields: this.use_custom_fields,
                language_code: this.languageCode,
                type_products: this.type_products,
                report_with_data: this.report_with_data,
                country_id: this.country_id,
            };
            if (!this.languageCode) {
                delete dataRepor.language_code;
            }
            this.setType('REPORTE-INVENTARIO');
            await this.generateScheduling(dataRepor);
            await this.showProccessBackground();
        },
        async generateScheduleGlobalInventoryReport() {
            const acls = getAcls();
            let dataRepor = {
                uuid: acls.uuid,
                in_use: this.in_use,
            };
            this.setType('REPORTE-INVENTARIO');
            await this.generateSchedulingGlobal(dataRepor);
            await this.showProccessBackground('SI');
        },
        ...mapActions("Reporteinventario", [
            "getEmpresas",
            "listarUbicacionesEmpresa",
            "getEmpresa",
            "scheduleInventoryReport",
        ]),
        ...mapActions("inventoryTypes", [
            "listInventoryType",
            "generateInventoryReport",
        ]),
        ...mapActions("productos", ["getEmpresaFiltroInventario"]),
        ...mapActions("background_processes", ["generateScheduling", "generateSchedulingGlobal", 'loadProccessBackground']),
        ...mapMutations("background_processes", ["setType", "setIsGlobalReport"]),
        ...mapMutations("Reporteinventario", [
            "setFiltroUbicacion",
            "limpiaEmpresa",
        ]),
        ...mapMutations("dashboard", ["load"]),
        _validarPermiso() {
            return true;
        },
        async showProccessBackground(isGlobalReport = 'NO') {
            this.setIsGlobalReport(isGlobalReport === 'SI');
            await this.loadProccessBackground({ type: 'REPORTE-INVENTARIO', company_id: this.companySelected.id, is_global_report: isGlobalReport }).then(async () => {
                await this.$bvModal.show('modal_process_background');
            });

        },
        limpiarEmpesaLocal() {
            this.limpiaEmpresa();
            this.country_id = null;
            this.val = null;
        },
        ...mapMutations("languages", ["setLanguages"]),
        ...mapActions("languages", ["getAllLanguages"]),
        ...mapActions("configurableVariables", ["getAllCountriesByCompany"]),
    },
    computed: {
        ...mapState("Reporteinventario", [
            "listaEmpresas",
            "selectedInventario",
            "ubicEmpresa",
            "empresa"
        ]),
        // Estados para el modulo de autentiaci{on}
        ...mapState("autenticacion", ['usuarioEmpresaContratista', 'my_company', 'locations_user']),
        ...mapState("languages", ["languages"]),
        ...mapState("configurableVariables", ["allCountries"]),
        ...mapState("location", ["treeWithChildrens"])
    },
    watch: {

        'inventoryTypeId'(nextState, prevState) {
            if (nextState != prevState && this.inventoryTypeId == 'ACT_INVENT') {
                this.report_with_data = "1"
            }
        },
        'allCountries'(nextState) {
            const mainCountry = nextState.find(item => item.is_main === true || item.is_main === 1);
            if (mainCountry) {
                this.country_id = mainCountry.country.id;
            } else if (nextState.length == 1) {
                this.country_id = nextState[0].country.id;
            }

            if (nextState.length == 0) {
                this.country_id = null;
            }
        },
        async country_id(newVal) {
            if (this.companySelected.id) {
                // limpiar selección de ubicaciones al cambiar país
                this.val = null;
                this.setFiltroUbicacion(null);

                this.getInventoryTypes();

                // Cargar ubicaciones con selección automática si el usuario tiene ubicaciones asignadas
                if (this.locations_user && this.locations_user.length > 0) {
                    const selectedLocationIds = await this.loadLocationsTreeWithMultipleAutoSelect(this.companySelected.id, this.locations_user, newVal || null, this.my_company);
                    if (selectedLocationIds && selectedLocationIds.length > 0) {
                        this.val = selectedLocationIds;
                        this.setFiltroUbicacion(selectedLocationIds);
                    }
                } else {
                    await this.loadLocationsTree(this.companySelected.id, newVal || null);
                }
            }
        }

    }
};
</script>
<style src="@riophae/vue-treeselect/dist/vue-treeselect.min.css"></style>
